import { Component, Input, Output, EventEmitter, AfterViewInit } from '@angular/core';

@Component({
    selector: 'main-content',
    templateUrl: 'main-content.component.html',
    styleUrls: ['main-content.component.scss'],
    standalone: false
})

export class MainContentComponent implements AfterViewInit {

  @Input() isBackdropOkay: boolean = true;
  @Input() isListVisible: boolean = true;
  @Input() isEveryoneSelected: boolean = false;
  @Output() changeLeftNavbar = new EventEmitter<boolean>();
  @Output() changeRightNavbar = new EventEmitter<boolean>();

  @Input() verticalRightIsVisible: boolean = false;
  @Input() verticalLeftIsVisible: boolean = true;
  @Input() verticalRightShow: boolean = true;
  @Input() verticalLeftShow: boolean = true;
  @Input() verticalLeftFixed: boolean = true;
  @Input() useLeftContent: boolean = false;

  constructor() { }

  ngAfterViewInit(): void {
    this.verticalLeftIsVisible = this.isListVisible;
  }

  public changeLeftNavbarVisible() {
    this.verticalLeftIsVisible = !this.verticalLeftIsVisible;
    this.changeLeftNavbar.emit(this.verticalLeftIsVisible);
  }

  public changeRightNavbarVisible() {
    this.verticalRightIsVisible = !this.verticalRightIsVisible;
    this.changeRightNavbar.emit(this.verticalRightIsVisible);
  }

}
